import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import { resetFilters } from '../actions';

export default compose(
  connect(null, {
    resetFilters,
  }),
  lifecycle({
    componentWillUnmount() {
      return this.props.resetFilters();
    },
  })
);
